import { OnboardingPage } from './onboardingPage';

export const onboardingRoutes = [
  {
    path: '/onboarding',
    element: <OnboardingPage />,
  },
];
